const ROMAN_NUMERALS = {
  M: 1000,
  CM: 900,
  D: 500,
  CD: 400,
  C: 100,
  XC: 90,
  L: 50,
  XL: 40,
  X: 10,
  IX: 9,
  V: 5,
  IV: 4,
  I: 1
};

function validateRomanInput(number) {
  return number.match(/(XXXX|IIII|CCCCC|MMMM|DD|LL|VV)/g) || number.match(/[\W\d]+/g) ? false : true;
}

function validateArabicInput(number) {
  return number > 0 && Number.isInteger(number) ? true : false;
}

function intToRoman(number) {
  if(validateArabicInput(number)){
    let roman = '';
    for (let i in ROMAN_NUMERALS) {
      while (number >= ROMAN_NUMERALS[i]) {
        roman += i;
        number -= ROMAN_NUMERALS[i];
      }
    }
    return roman;
  }
  return 'Invalid Input';
}

function romanToInt(number) {
  number = number.toUpperCase();
  if (validateRomanInput(number)) {
    let arabic = 0;
    let previous = '';
    for (let current of number) {
      if (ROMAN_NUMERALS[previous] < ROMAN_NUMERALS[current]) {
        arabic += (ROMAN_NUMERALS[current] - ROMAN_NUMERALS[previous] * 2);
      } else {
        arabic += ROMAN_NUMERALS[current];
      }
      previous = current;
    }
    return arabic;
  }
    return 'Invalid Input';
}


module.exports.intToRoman = intToRoman;
module.exports.romanToInt = romanToInt;